import script from "./RequirementForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequirementForm.vue?vue&type=script&lang=ts&setup=true"

import "./RequirementForm.vue?vue&type=style&index=0&id=6f6fb64e&lang=scss"

const __exports__ = script;

export default __exports__